// extracted by mini-css-extract-plugin
export default {"cls1":"G54tZakAyqWUvOiy_QVX","cls2":"avSuMU6VGuB4qLyCOK_O G54tZakAyqWUvOiy_QVX"};